export default "__VITE_ASSET__3b8b217e__"